<template>
    <div class="card">
        <div class="card-content">
            <div class="columns">
                <div class="column is-1 has-text-centered">
                    <p class="main-icon title has-text-danger">
                        <span class="icon">
                            <i class="fas fa-gavel"></i>
                        </span>
                    </p>
                </div>
                <div class="column">
                    <p>BIDDING DEPOSIT: <strong>{{ balance }}$</strong></p>
                    <p>MAX BIDS ALLOWED: <strong>{{ maxBids() }}</strong></p>
                </div>
                <div class="column">
                    <p>CREDIT: <strong>---</strong></p>
                    <p>BIDDING RATIO: <strong>---</strong></p>
                </div>
                <div class="column">
                    <p>LAST POSSIBLE DAY TO BID: <strong>---</strong></p>
                    <p></p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import apiAuth from './../../api/apiAuth'
    export default {
        data () {
            return {
                balance: this.$store.getters.getCurrentUser.info.balance.amount,
                info: this.$store.getters.getCurrentUser.info
            }
        },
        methods: {
            maxBids () {
               return this.info.settings.max_group_win * this.info.settings.max_groups + '/' + this.$store.getters.getCurrentUser.info.bid.length
            }
        },
        mounted () {

        }
    }
</script>

<style scoped>
    .main-icon {
        font-size: 3rem;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Bidding.vue